import {
    DATIQ_DEFAULT_BOOLEAN,
    DATIQ_DEFAULT_EMPTY_LABEL,
} from '@dat/datiq-core/models';
import { DatiqTooltipTypes } from './datiq-tooltip.enum';
import { IDatiqTooltip } from './datiq-tooltip.interface';

export const emptyDatiqTooltip: IDatiqTooltip = {
    title: DATIQ_DEFAULT_EMPTY_LABEL,
    type: DatiqTooltipTypes.Info,
    icon: `app:help`,
    hideIcon: DATIQ_DEFAULT_BOOLEAN,
};
